import React from "react";

const SvgTrends = props => (
  <svg viewBox="0 0 215 215" {...props}>
    <path
      d="M100.2 19.5c-44.7.3-80.8 36.8-80.5 81.5.1 21.7 9 42.4 24.5 57.5l56-58.5V19.5z"
      fill="currentColor"
    />
    <path
      d="M111 23.9h-.7c-1.1.1-1.9 1-1.9 2v79.6l-55.5 58c-.8.8-.8 2.1 0 2.9 32.8 32 85.4 31.4 117.5-1.5s31.4-85.4-1.5-117.5c-15.5-15-36.2-23.4-57.9-23.5zm0 162.1c-19.9 0-39.1-7.5-53.7-21l54.7-57.1c.4-.4.6-.9.6-1.4V28.1c43.6.8 78.3 36.8 77.5 80.4-.8 43-36 77.5-79.1 77.5z"
      fill="currentColor"
    />
  </svg>
);

export default SvgTrends;